/**
 * Mixin para verificar se o trial do usuário expirou.
 * Adiciona computed properties: isTrialExpired, trialDaysLeft, hasActiveSubscription
 * e o URL de checkout para upgrade.
 */
export default {
  computed: {
    trialUserData() {
      try {
        return JSON.parse(localStorage.getItem('userData')) || {}
      } catch {
        return {}
      }
    },
    isTrialExpired() {
      if (this.trialUserData.user_role === 'admin') return false
      return !!this.trialUserData.trialExpired
    },
    trialDaysLeft() {
      return this.trialUserData.trialDaysLeft || 0
    },
    hasActiveSubscription() {
      return !!this.trialUserData.hasActiveSubscription
    },
    kiwifyCheckoutUrl() {
      return 'https://pay.kiwify.com.br/tc9OIFy'
    },
  },
}
